import { FC } from 'react';

import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

const SKELETON_COUNT = 8;
export const ShelvesSkeleton: FC<{ className?: string }> = ({
  className,
}: {
  className?: string;
}) => (
  <div className={cn('flex flex-col gap-2', className)}>
    <div className='page-top-container'>
      <Skeleton className='h-4 w-24' />
      <Skeleton className='h-4 w-48' />
    </div>
    <div className='grid grid-cols-1 gap-6 px-4 pt-2 pb-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'>
      {Array.from({ length: SKELETON_COUNT }).map((_, index) => (
        <Skeleton
          key={index}
          className='aspect-[4/3] w-full rounded-xl'
        />
      ))}
    </div>
  </div>
);
